/**
 * Validation messages. They are English catalog keys (the web translates issue messages as-is), so
 * they carry no dynamic values and say what to do next.
 */
export const ISSUES = {
  male: "Only a cow or heifer can be bred, checked or calve. This animal is recorded as male.",
  femaleIsMale: "One of the cows is recorded as male. Check the tags.",
  bullNotMale: "The bull has to be a male animal.",
  departed: "This animal is no longer in the herd. Record only what happened before she left.",
  reference: "Reference animals (outside sires and ancestors) can't be bred, checked or calved here.",
  future: "That date is in the future. Plans go in a task or a job, not in a record.",
  calvingDuplicate: "This cow already has a calving recorded within a few days of this date. If it's the same birth, correct that record instead of adding another.",
  calvingTooSoon: "This cow has another calving less than eight months from this date. Check the dates, or correct the earlier record.",
  calfNotListed: "Each calf on this record also needs to be in the calves list.",
  calfNotSubject: "Each calf in the calves list needs to be on the record as a calf too.",
  calfIsDam: "A cow can't be her own calf.",
  calfOtherDam: "That calf is already recorded with a different dam.",
  calfHasBirth: "That calf already has a birth record. Correct that record instead.",
  calfBirthFar: "That calf's birth date is far from this calving date. Check you picked the right calf.",
  checkTooSoon: "She calved less than 30 days before this check, so she can't be confirmed pregnant yet.",
  fetalBeforeCalving: "That fetal age puts conception before her last calving. Check the age or the date.",
  fetalBeforeBirth: "That fetal age puts conception before she was born. Check the age or the date.",
  semenKind: "Pick a semen lot for AI.",
  semenSire: "That semen is from a different bull than the sire you picked.",
  embryoKind: "Pick an embryo lot for the transfer.",
  sireFemale: "The sire has to be a bull.",
  donorIsRecipient: "The donor and the recipient have to be different cows.",
  nurseIsCalf: "The nurse cow and the calf have to be different animals.",
  nurseIsDam: "That's the calf's own dam. Grafting puts a calf on a different cow.",
  nurseMale: "The nurse has to be a cow or heifer.",
  exposureFemales: "List the cows the bull was with, or pick the group.",
  overrideReason: "Say why you're keeping this animal despite an unsatisfactory exam.",
  scoreScale: "That score is outside the scale you picked.",
  syncActions: "Say what was done: CIDR in, a shot, and so on.",
  ageUnit: "Give the fetal age in days, weeks or months.",
  ageNotPregnant: "Fetal age only goes with a pregnant result.",
  recheckNotPending: "A recheck date only goes with a recheck result.",
  sireMissing: "Pick the sire, or mark the sire as not known.",
  weightBasis: "Add the birth weight, or clear how it was taken.",
  noSteps: "Add the protocol's steps.",
  serviceDuplicate: "This breeding is already recorded for her at that time. Correct that record if something changed, like a second straw.",
} as const;

export const ISSUE_MESSAGES: string[] = Object.values(ISSUES);
